import type { ComponentPropsWithRef } from 'react'

import { cn } from '../lib/cn'
import { classesChamp } from './champ'

export interface TextareaProps extends ComponentPropsWithRef<'textarea'> {
  readonly invalide?: boolean | undefined
}

export function Textarea({ invalide = false, className, rows = 3, ...reste }: TextareaProps) {
  return (
    <textarea
      rows={rows}
      className={cn(classesChamp(invalide, true), 'resize-y leading-relaxed', className)}
      aria-invalid={invalide || undefined}
      {...reste}
    />
  )
}
